import { Box, Typography } from "@mui/material"
import React from "react"
import city from "../../../../assets/img/city.png"
import { HomePageButton } from "./HomePageButton"
import { resolveUrl } from "../../../core/services/http-service"
import { pagesUrl } from "../../../core/appConstants"

export function NewProjectCard(): React.JSX.Element {
  return (
    <Box
      borderRadius={3}
      sx={{
        minHeight: "250px",
        background: "white",
        boxShadow: "2px 4px 20px 0px rgba(0, 0, 0, 0.05)",
        p: 3,
        display: "flex",
        flexDirection: "row",
      }}>
      <Box sx={{ display: "flex", alignContent: "center", alignItems: "center" }}>
        <img
          src={city}
          alt={city}
          height="200px"
          width="max-content"
          style={{
            marginLeft: 15,
            marginTop: -8,
          }}
        />
      </Box>

      <Box sx={{ display: "flex", flexDirection: "column", justifyContent: "space-between", gap: 2 }}>
        <Typography variant="h6">Créer un nouveau projet</Typography>
        <Typography variant="body1">
          Estimez l’impact carbone de votre projet avec Shot ou générez vos tableaux de bord RSEE avec Pilot, simplement et
          rapidement.
        </Typography>

        <HomePageButton label="Créer un projet" path={resolveUrl(pagesUrl.PROJECTS_PAGE, [], { create: true })} />
      </Box>
    </Box>
  )
}
